
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SUPPORTED_LANGUAGES = ['en', 'pt', 'es', 'fr', 'it', 'de'];

const LegacyRedirect = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { i18n } = useTranslation();

    useEffect(() => {
        const currentLang = i18n.language || localStorage.getItem('selectedLanguage') || 'en';
        const path = location.pathname;
        const search = location.search;

        // Proteção contra loops infinitos:
        // Se o path já começa com /{lang}/, não adiciona outro prefixo de língua.
        const pathParts = path.split('/').filter(Boolean); // remove strings vazias
        if (pathParts.length > 0 && SUPPORTED_LANGUAGES.includes(pathParts[0])) {
            // O path já tem prefixo de língua válido — não redirecionar para evitar loop
            return;
        }

        const cleanPath = path === '/' ? '' : path;
        navigate(`/${currentLang}${cleanPath}${search}`, { replace: true });

    }, [navigate, location, i18n]);

    return null;
};

export default LegacyRedirect;
